(function () {
    'use strict';

    angular
        .module('ipmApp')
        .directive('agreementPcsgInformationPoliciesComponent', agreementPcsgInformationPoliciesComponent);

    agreementPcsgInformationPoliciesComponent.$inject = [];

    function agreementPcsgInformationPoliciesComponent() {
        var directive = {
            restrict: 'EA',
            scope: {
                workflow: '='
            },
            link: linkFunc,
            controller: DirectiveAgreementPcsgInformationPoliciesController,
            templateUrl: 'app/psych-intake/workflow/partial/directive/agreement-pcsg-information-policies.directive.html',
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function linkFunc(scope, element, attrs) {

        }
    }

    DirectiveAgreementPcsgInformationPoliciesController.$inject = ['$scope', '$stateParams', '$element'];
    function DirectiveAgreementPcsgInformationPoliciesController($scope, $stateParams, $element) {
        var vm = this;

        function init() {
            if (vm.workflow.answer.agreement) {
                if (vm.workflow.answer.agreement.dateSigned === null || vm.workflow.answer.agreement.dateSigned === undefined) {
                    vm.workflow.answer.agreement.dateSigned = new Date(); // default dateSigned is today
                }
            }
        }

        init();
    }
})();
